export const locales = ['de', 'en', 'tr', 'fr', 'ar', 'es'] as const;
export type Locale = (typeof locales)[number];
export const defaultLocale: Locale = 'de';

export const localeNames: Record<Locale, string> = {
  de: 'Deutsch',
  en: 'English',
  tr: 'Türkçe',
  fr: 'Français',
  ar: 'العربية',
  es: 'Español',
};

export const localeFlags: Record<Locale, string> = {
  de: '🇩🇪',
  en: '🇬🇧',
  tr: '🇹🇷',
  fr: '🇫🇷',
  ar: '🇸🇦',
  es: '🇪🇸',
};

export const rtlLocales: Locale[] = ['ar'];

export function isRTL(locale: Locale): boolean {
  return rtlLocales.includes(locale);
}

export const localePrefix = 'as-needed' as const;
